import { render } from "./StructuralParts.vue?vue&type=template&id=52cb7d2f"
import script from "./StructuralParts.vue?vue&type=script&lang=js"
export * from "./StructuralParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__